import { RouterState } from 'mobx-state-router';

const getAppRouterState = routeName => {
	return new RouterState(routeName);
};

export default getAppRouterState;
